import { render, staticRenderFns } from "./orderinfo.vue?vue&type=template&id=497af9e0&scoped=true"
import script from "./orderinfo.vue?vue&type=script&lang=js"
export * from "./orderinfo.vue?vue&type=script&lang=js"
import style0 from "./orderinfo.vue?vue&type=style&index=0&id=497af9e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497af9e0",
  null
  
)

export default component.exports